"use client";
import React from "react";
import Movies from "../../Components/movies/page";
import Archive from "../../Components/archive/page";
import NewsGrabbing from "../../Components/newsGrabbing/page";
import getBlogs from "@/app/lib/getBlogs";
import { useEffect, useState } from "react";
import Link from "next/link";

//images

import Movie from "/public/Images/spotlight.svg";
import BlogDrop from "../../Components/blogchangDrop/page";

export default function page() {
  const [blogs, setblogs] = useState([]);
  const [news, setNews] = useState([]);
  const [movieBlogs, setMovieBlogs] = useState([]);
  const [tvs, setTvs] = useState([]);



  useEffect(() => {
    const fetchData = async () => {
      const blogs = await getBlogs();
      setblogs(blogs?.reverse());
      setMovieBlogs(blogs?.filter((blog) => blog.category === "movie"));
      setNews(blogs?.filter((blog) => blog.category === "News"));
      setTvs(blogs?.filter((blog) => blog.category === "TV"));
    };

    fetchData();
  }, []);
  return (
    <div>

      {/* herosection */}
      <div className="flex flex-wrap max-ipad:flex-wrap mx-[4%]">
        <div className="mt-10 w-full">
          <>
            <Link
              href={`/ReadBlog/${blogs[0]?._id}`}
              className="block shadow-lg max-ipad:m-2"
            >
              <div className="relative">
                <img
                  src={blogs[0]?.thumbnail}
                  alt="cinema drip blog slider thumbnail"
                  className=" h-[800px] max-ipad:h-[350px] w-full"
                />
                {/* <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-[#39353574] " /> */}
                <div className="top-blogs-section absolute bottom-0 w-full">
                  <div className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] border p-2 flex flex-col items-center justify-center m-auto w-fit relative bottom-5">
                    <div className="bg-white w-full pb-1 px-4">
                      <h1 className="bg-gradient-to-r from-[#00ECD4] to-[#6260FA] bg-clip-text text-transparent poppins capitalize text-center leading-tight mt-2 text-[30px] font-bold">
                        Pick Of The Day
                      </h1>
                    </div>
                  </div>
                  <div
                    className="bg-custom-gradient w-full py-8 px-8"
                    style={{ backdropFilter: "blur(25px)" }}
                  >
                    <h1 className="text-[#ffffff] poppins capitalize text-center leading-tight text-[32px] font-semibold max-ipad:text-[20px]">
                      {blogs[0]?.category}
                    </h1>
                    <div className="bg-gradient-to-r from-[#ffffff] to-[#ffffff] h-1 w-24 m-auto" />
                    <h3 className="text-[#ffffff] font-semibold poppins text-[30px] text-center mt-2 capitalize max-ipad:text-[18px]">
                      {blogs[0]?.title}
                    </h3>
                    <p
                      className="text-[#ffffff] text-center mt-2 text-[16px] poppins"
                      style={{
                        width: "100%",
                        maxWidth: "733px",
                        margin: "auto",
                      }}
                    >
                      {blogs[0]?.subtitle}
                    </p>
                    <p className="text-center uppercase font-[300] mt-1 text-[#ffffff]">
                      BY&nbsp;{blogs[0]?.author}
                    </p>
                  </div>
                </div>
              </div>
            </Link>
          </>
        </div>
      </div>
      {/* TV Awards section */}
      <BlogDrop data= {tvs}/>
      {/* Movies section */}
      <Movies title={"Movies"} category={"movie"} icon={Movie} newsBlogs={movieBlogs}/>
      {/* Archive section */}
      <Archive archives={blogs} />
      {/* grab news inline */}
      <NewsGrabbing news={news}/>
    </div>
  );
}
